
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"43","height":"43","viewBox":"0 0 43 43"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.493 32.048c8.217-3.491 12.047-12.983 8.556-21.201C28.555 2.629 19.064-1.2 10.847 2.292 2.632 5.784-1.201 15.276 2.293 23.494c3.491 8.217 12.982 12.046 21.2 8.554zM29 29l12.766 12.766","stroke":"#8D8D8D","stroke-width":"1.5","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    